import axios from './../helper/axiosIntance';
import { normalizeStringInObject } from "../utils/normalize";
function getFormData(object) {
    const formData = new FormData();
    if (object) {
        Object.keys(object).forEach(key => formData.append(key, object[key]));
    }
    return formData;
}


const add = (params) => {
    return axios.post('/contact/api/add', normalizeStringInObject(params));
}
const view = (params) => {
    return axios.post('/contact/api/view', getFormData(normalizeStringInObject(params)));
};
const view2 = (params) => {
    if (params.exportContact) {
        return axios.post('/contact/api/view2', params, { responseType: 'blob' });
    }
    return axios.post('/contact/api/view2', normalizeStringInObject(params));
};
const view3 = (params) => {
    if (params?.exportContact) {
        return axios.post('/contact/api/view3', params, { responseType: 'blob' });
    }
    return axios.post('/contact/api/view3',normalizeStringInObject(params))
};
const quick_edit = (params) => {
    return axios.post(`/contact/api/quick_edit`, normalizeStringInObject(params));
};
const edit = (params) => {
    return axios.post(`/contact/api/edit`, getFormData(normalizeStringInObject(params)));
};
const delete_force = (params) => {
    return axios.post(`/contact/api/deleteContact`, getFormData(normalizeStringInObject(params)));
};
const find = (params) => {
    return axios.post(`/contact/api/find`, getFormData(normalizeStringInObject(params)));
};
const get_info_contact = (params) => {
    return axios.post(`/contact/api/get_info_contact`, getFormData(normalizeStringInObject(params)));
};
const merge_contact = (params) => {
    return axios.post(`/contact/api/merge_contact`, getFormData(normalizeStringInObject(params)));
};
const add_field_contact = (params) => {
    return axios.post(`/contact/api/add_field_contact`, normalizeStringInObject(params));
};
const edit_field_contact = (params) => {
    return axios.post(`/contact/api/edit_field_contact`, normalizeStringInObject(params));
};
// const edit_field_contact_type_select = (params) => {
//     return axios.post(`/contact/api/edit_field_contact_select`, params);
// };
const delete_field_contact = (params) => {
    return axios.post(`/contact/api/delete_field_contact`, normalizeStringInObject(params));
};
const list_field_contact = (params) => {
    return axios.post(`/contact/api/list_field_contact`, normalizeStringInObject(params));
};
const dowload_template_contact = (params) => {
    return axios.post('/contact/api/dowload_template_contact', normalizeStringInObject(params), { responseType: 'blob' });
}
const upload_contact = (params) => {
    return axios.post('/contact/api/upload_contact', params);
}
const find_list_chat = (params) => {
    return axios.post('/contact/api/find_list_chat', normalizeStringInObject(params));
}
const edit_tag = (params) => {
    return axios.post('/contact/api/editTag', normalizeStringInObject(params));
}
const delete_tag = (params) => {
    return axios.post('/contact/api/delete_tag', normalizeStringInObject(params));
}
const write_note = (params) => {
    return axios.post('/contact/api/updateNoteOfContact', normalizeStringInObject(params));
}
const write_note_calling = (params) => {
    return axios.post('/contact/api/updateNoteOfHistoryCall', normalizeStringInObject(params));
}
const write_note_call_by_callid = (params) => {
    return axios.post('/contact/api/writeNoteOfHistoryCallByCallid', params);
}
const show_note_call = (params) => {
    return axios.post('/contact/api/showNoteOfHistoryCall', params);
}
const check_customer_other = (params) => {
    return axios.post(`/contact/api/check_customer_other`, getFormData(params));
};
const saveChangeTransferContact = (params) => {
    return axios.post(`/contact/api/saveChangeTransferContact`, params);

}
const deleteContactByIds = (params) => {
    return axios.post(`/contact/api/deleteContactByIds`, getFormData(params));

}
const changeIndexFieldContact = (params) => {
    return axios.post(`/contact/api/changeIndexFieldContact`, params);

}
export default {
    saveChangeTransferContact,
    list_field_contact,
    add,
    view,
    view2,
    edit,
    quick_edit,
    find,
    delete_force,
    get_info_contact,
    add_field_contact,
    edit_field_contact,
    //edit_field_contact_type_select,
    edit_tag,
    delete_field_contact,
    merge_contact,
    dowload_template_contact,
    upload_contact,
    find_list_chat,
    view3,
    delete_tag,
    write_note,
    write_note_calling,
    check_customer_other,
    show_note_call,
    write_note_call_by_callid,
    deleteContactByIds,
    changeIndexFieldContact,
}
